export default {
  groupTodo: 'To-dos',
  groupProject: 'Projects',
  groupAssets: 'Data assets',
  groupPlatform: 'Platform',
  groupSysAdmin: 'System',
  groupFinance: 'Finance',
  groupAdmin: 'Administration',
  groupSuperAdmin: 'Super Admin',
  bizStats: 'Business analytics',
  todoTasks: 'Task inbox',
  photoLive: 'Photo Live',
  cloudSpace: 'Cloud storage',
  conference: 'Events',
  eventManage: 'Events',
  registrationManage: 'Questionnaires',
  venueManage: 'Seating & venues',
  hotelManage: 'Hotels',
  receptionManage: 'Reception',
  donationManage: 'Donations',
  cardManage: 'Name cards',
  memberManage: 'Members',
  memberPlan: 'Membership plans',
  referralConfig: 'Referral settings',
  accountManage: 'Accounts',
  roleManage: 'Roles',
  permissionManage: 'Permissions',
  companyManage: 'Companies',
  resourceGrantManage: 'Resource grants',
  attendeeManage: 'Attendees',
  staffManage: 'Staff',
  orderRecords: 'Orders',
  assetManage: 'Assets',
  refundManage: 'Refunds'
}
